import TextField from './fields/TextField';
import SelectField from './fields/SelectField';
import MultiSelectField from './fields/MultiSelectField';
import CheckboxField from './fields/CheckboxField';
import RadioField from './fields/RadioField';
import DateField from './fields/DateField';
import TextAreaField from './fields/TextAreaField';
import FileField from './fields/FileField';
import SignatureField from './fields/SignatureField';
import AddressBlock from './fields/AddressBlock';
import ObjectIdRefField from './fields/ObjectIdRefField';
import ObjectIdRefMultiField from './fields/ObjectIdRefMultiField';
import DynamicArrayField from './fields/DynamicArrayField';
import SectionHeader from './fields/SectionHeader';

const FieldRegistry = {
    text: TextField,
    email: TextField,
    tel: TextField,
    number: TextField,
    select: SelectField,
    multiselect: MultiSelectField,
    checkbox: CheckboxField,
    radio: RadioField,
    date: DateField,
    textarea: TextAreaField,
    file: FileField,
    signature: SignatureField,
    address: AddressBlock,
    objectIdRef: ObjectIdRefField,
    objectIdRefMulti: ObjectIdRefMultiField,
    dynamicArray: DynamicArrayField,
    section: SectionHeader,
    hidden: null
};

export default FieldRegistry;
